@use "Styles/mixins" as mixins;

:host {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px 0;
    border-top: 1px solid mixins.get-color(border, transparent, primary);
    border-bottom: 1px solid mixins.get-color(border, transparent, primary);
    background-color: mixins.get-color(bg, solid, secondary);

    @include mixins.desktop-and-up() {
        margin: 0;
        padding: 0;
        border: none;
        background-color: unset;
    }

    * {
        box-sizing: border-box;
    }

    .video-chapters-title {
        @include mixins.text-medium-medium();
        margin: 0 16px;
        color: mixins.get-color(text, text-primary);

        @include mixins.desktop-and-up() {
            display: none;
        }
    }

    .video-chapters-slider {
        display: block;

        @include mixins.desktop-and-up() {
            margin: 24px 0;
        }
    }
}
